import {inject, Injectable} from '@angular/core';
import {ButtonRecordValue, RecordData, RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {defaultPageableRecordData} from "../../../../core/models/default-pageable-record-data";
import {ErrorService} from "../../../../core/services/error.service";
import {Pageable} from "../../../../core/types/pagable.types";
import {RecordTableApiService} from "../../../../core/services-api/record-table-api.service";
import {marketplaceTypes} from "../configs/marketplace-config";
import {ArticleMarketplaceData} from "../types/marketplace.types";

@Injectable({
  providedIn: 'root'
})
export class ArticleMarketplaceService {
  private errorService: ErrorService = inject(ErrorService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public async getMarketplaceData(path: string, queryParams: RecordsDataRequestQueryParams): Promise<Array<ArticleMarketplaceData>> {
    const response = await this.getRecordData(path, queryParams).catch(() => defaultPageableRecordData);
    const marketplaceType = marketplaceTypes[path];

    return response.content?.map((item: RecordData) => {
      switch (marketplaceType) {
        case 'wildberries':
          return {
            title: item['title'] as string,
            id: Number(item.id),
            nmId: Number(item['nmId']),
            productCardId: (item['productCard'] as ButtonRecordValue).id
          };
        case 'ozon':
          return {
            title: item['name'] as string,
            id: Number(item.id),
            productCardId: (item['productCard'] as ButtonRecordValue).id
          };
        default:
          this.errorService.showErrorMessage(`Unknown marketplace type for path: ${path}`);
          return {};
      }
    }) || [];
  }

  private getRecordData(path: string, queryParams: RecordsDataRequestQueryParams): Promise<Pageable<RecordData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchRecordTableData(path, queryParams).subscribe({
        next: (recordsTableData: Pageable<RecordData>) => resolve(recordsTableData),
        error: (error) => reject(error)
      });
    });
  }
}
